import { useCallback, useState, useEffect, useRef } from 'react'

export const useHash: () => [string, (newValue: string) => void] = () => {
    const [hash, setHash] = useState(() => window.location.hash)

    const hashChangeHandler = useCallback(() => {
        setHash(window.location.hash)
    }, [])

    useEffect(() => {
        window.addEventListener('hashchange', hashChangeHandler)
        return () => {
            window.removeEventListener('hashchange', hashChangeHandler)
        }
    }, [])

    const updateHash = useCallback(
        (newHash: string) => {
            if (newHash !== hash) window.location.hash = newHash
        },
        [hash]
    )

    return [hash, updateHash]
}

export function usePackedHash<T>(pack: (arg: T) => string, unpack: (arg: string) => T, initial: T): [T, (arg: T) => void] {
    const [hash, setHash] = useHash()
    const unpacked = hash ? unpack(hash.substring(1)) : initial
    const setPack = (arg: T) => { setHash(pack(arg)) }
    return [unpacked, setPack]
}

export function useDidMount(callback: any) {
    const didMount = useRef<boolean|null>(null)

    useEffect(() => {
        if (callback && !didMount.current) {
            didMount.current = true
            callback()
        }
    })
}